import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

// Sider
import Forside from './pages/Forside';
import YdelseDetail from './pages/YdelseDetail';
import Projekter from './pages/Projekter';
import OmMikkel from './pages/OmMikkel';
import Kontakt from './pages/Kontakt';
import Error404 from './pages/Error404';
import Error403 from './pages/Error403';

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-brand-cream text-brand-dark antialiased">
        {/* Navigation */}
        <Header />

        {/* Hovedindhold */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/ydelser/:slug" element={<YdelseDetail />} />
            <Route path="/projekter" element={<Projekter />} />
            <Route path="/om-mikkel" element={<OmMikkel />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

export default App;
